module.exports = __webpack_public_path__ + "static/media/sd.8026a6bf.png";